import fetchUploadTutorial from '@data/tutorial/upload';
import { useQuery } from '@tanstack/react-query';

const getUploadTutorial = () => {
    return useQuery({
        queryKey: ['upload-tutorial'],
        queryFn: () => fetchUploadTutorial(),
        staleTime: Infinity,
    });
};

export default getUploadTutorial;
